import * as actions from "./authorization.actions";
import * as types from "./authorization.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { AuthorizationReducerType } from "./types";

export type UserActions = ActionType<typeof actions>;

export const initialState: AuthorizationReducerType = {
  token: '',
  message: '',
  error: null,
  isLoading: true,
  systemAccess: {},
  authorizedUser: null
};

export const AuthorizationReducer = createReducer<
AuthorizationReducerType,
  UserActions
>(initialState)
  .handleAction(actions.getUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getUserAsync.success, (state, action) => ({
    ...state,
    authorizedUser: action.payload.response.data,
    systemAccess: action.payload.systemAccess,
    token: action.payload.token,
    error: null,
    isLoading: false,
  }))
  .handleAction(actions.getUserAsync.failure, (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.SET_MESSAGE as any, (state, action) => ({
    ...state,
    message: action.payload.value
  }));
